import { useContext } from "react";
import { BannerContext } from "../providers/BannerProvider";
import { BannerContextType } from "../types";

export const useBanner = (): BannerContextType => {
  const context = useContext(BannerContext);

  if (!context) {
    throw new Error("useBanner must be used within a BannerProvider");
  }

  return context;
};
